export enum AuthActionTypes {
  LOGIN_REQUEST = "login",
  LOGIN_SUCCESS = "login-success",
  LOGIN_FAILURE = "login-failure",
  LOGOUT = "logout",
  GET_USER = "get-user",
  CREATE_USER = "create-user",
}
